import * as React from 'react';
import ApplicationState from 'src/application/core/State';
import TableHeader from '../../TableHeader';
import '../../CustomTable.css';
import '../../Summary.css';
import SummaryDetails, { SummaryData } from '../../SummaryDetails';
import { ItemDetail, ItemDetailToExport } from '../../../domain/SummaryData';
import OrderSummaryData from '../../../domain/SummaryData';
import ItemDetails from '../../ItemDetails';
import { connect } from 'react-redux';
import DispatchProps from '../../../application/core/DispatchProps';
import ExportDataToExcel, { Column } from '../../ExportDataToExcel';
import triggerClickOnExcelDownload from '../../triggerClickOnExcelDownload';
import createExcelFileName from '../../createExcelFileName';
import createDetailsExcelData from '../../createDetailsExcelData';
import Product from '../../../domain/Product';
import { removeDecimals } from '../../../domain/calculatePrice';
import orderStatusTranslator from '.././OrderStatusTranslator';
import formatNumber, { formatPrice } from '../../formatNumber';
import Loader from '../../common/Loader';
import Role from '../../../domain/Role';

interface StateProps {
    order: OrderSummaryData | null;
    products: Product[];
    userRole: Role;
    shippingMethod: string;
}

interface State {
    spreadsheetData: ItemDetailToExport[];
}

interface Props {
    goBackLink: JSX.Element;
}

class ViewOrder extends React.PureComponent<Props & StateProps & DispatchProps, State> {
    constructor(props: Props & StateProps & DispatchProps) {
        super(props);
        this.state = {
            spreadsheetData: []
        };
    }

    public render(): JSX.Element {
        if (!this.props.order) {
            return <Loader />;
        }
        const headers = ['Name', 'Qty', 'Price', 'SKU', 'Subtotal'];

        let detailsData: SummaryData[] = [
            { text: 'Order no', value: this.props.order.id },
            { text: 'Order date', value: this.props.order.placeDate },
            {
                text: 'Status',
                value: this.props.userRole === Role.User ? orderStatusTranslator(this.props.order.status) : this.props.order.status
            },
            { text: 'Quantity', value: formatNumber(this.props.order.quantity, 0) },
            { text: 'Total', value: formatPrice(removeDecimals(this.props.order.totalCost)) }
        ];
        detailsData =
            this.props.shippingMethod !== ''
                ? [...detailsData, { text: 'DAP', value: removeDecimals(this.props.order.deliveryFee) }]
                : detailsData;

        const spreadsheetColumns: Column[] = [
            {
                label: 'SKU',
                value: 'sku'
            },
            {
                label: 'Name',
                value: 'name'
            },
            {
                label: 'Variant code',
                value: 'variantCode'
            },
            {
                label: 'Size',
                value: 'size'
            },
            {
                label: 'Quantity',
                value: 'quantity'
            },
            {
                label: 'Price',
                value: 'discountedPrice'
            },
            {
                label: 'Package size',
                value: 'packageSize'
            },
            {
                label: 'Subtotal',
                value: 'subTotal'
            }
        ];

        return (
            <div className="summary-container">
                <SummaryDetails data={detailsData} goBackLink={this.props.goBackLink} onExportClicked={this.onExportClicked} />
                <ExportDataToExcel
                    spreadsheetData={this.state.spreadsheetData}
                    name="Order"
                    columns={spreadsheetColumns}
                    filename={createExcelFileName('Order', new Date(), this.props.order.placeDate)}
                />
                <div className="custom-table">
                    <TableHeader headers={headers} class={'custom-table-header'} />
                    <div className="custom-table-body">
                        {this.props.order.items.map((item: ItemDetail) => (
                            <ItemDetails item={item} key={item.sku} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    private onExportClicked = (): void => {
        this.setState({ spreadsheetData: createDetailsExcelData(this.props.order!.items) }, () => {
            triggerClickOnExcelDownload('estimations-download-button');
            this.setState({ spreadsheetData: [] });
        });
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    order: state.order.orderDetails,
    products: state.products.orderProducts,
    userRole: state.user.role,
    shippingMethod: state.user.shippingMethod
});

export default connect(mapStateToProps)(ViewOrder);



// WEBPACK FOOTER //
// ./src/view/order/details/ViewOrder.tsx